import React from 'react';
import { useTranslation } from 'react-i18next';
import { LiliLinkButton, LiliLinkType } from '@lili/lili-frontend-common';

interface RoleItemRemoveProps {
  onClick: () => void;
  allowRemove: boolean;
  isAuthorizedUser: boolean;
}

export const RoleItemRemove = ({ onClick, allowRemove, isAuthorizedUser }: RoleItemRemoveProps) => {
  const { t } = useTranslation();

  return (
    <div className='flex flex-col items-center gap-2'>
      {allowRemove && (
        <LiliLinkButton
          title={isAuthorizedUser ? 'Cancel my Access' : t('ACCOUNT_SETTINGS.TEAM.TABLE.REMOVE_BUTTON')}
          id='settings-item-edit-button'
          onClick={(e) => {
            e.preventDefault();
            onClick();
          }}
          type={LiliLinkType.SMART}
        />
      )}
    </div>
  );
};
